import { render, staticRenderFns } from "./CreateNewDeckMsg.vue?vue&type=template&id=a5dcb13c&scoped=true&"
import script from "./CreateNewDeckMsg.vue?vue&type=script&lang=js&"
export * from "./CreateNewDeckMsg.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewDeckMsg.vue?vue&type=style&index=0&id=a5dcb13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dcb13c",
  null
  
)

export default component.exports